import React, {useEffect} from 'react';
import {Redirect, Route, Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import history from './history';
import LoginForm from './pages/LoginForm';
import Welcome from './pages/Welcome';
import QuestionPage2 from './pages/QuestionPage2';
import Summary from './pages/Summary';
import { readAttemptSummary } from './utils/attemptSummary';
// import Topbar from './components/Topbar'
import Footer from './components/Footer';
import Scroll from './components/Scroll';
import {fetchUser, signout} from './actions'
import { ToastContainer } from 'react-toastify';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
// import NetworkConnectionModal from './components/modals/NetworkConnectionModal';


function App(props) {

  useEffect( () => {
      const summaryRoute = history.location.pathname.match(/^\/exams\/([^/]+)\/summary\/?$/);
      if (summaryRoute && readAttemptSummary(summaryRoute[1])) return;
      props.fetchUser();
      // if (props.isSignedIn) history.push('welcome');
    },[]);

  let routes;

  if (props.isSignedIn) {
    routes = (
      <React.Fragment>
            {/* <!-- Page Wrapper --> */}

            <div id="wrapper">
                
                  
                {/* Sidebar */}
                {/* <Sidebar /> */}
                {/* End of Sidebar */}

                {/* <!-- Content Wrapper --> */}
                <div id="content-wrapper" className="d-flex flex-column">

                    {/* <!-- Main Content --> */}
                    <div id="content">

                        {/* <!-- Topbar --> */}
                        {/* <Topbar /> */}
                        {/* <!-- End of Topbar --> */}

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            {/* <!-- Page Heading --> */}
                            {/* <h1 className="h3 mb-4 text-gray-800">Blank Page</h1> */}
                            <Switch>
                              <Route exact path="/welcome" component={Welcome} />
                              <Route exact path="/exams/:id" render={routeProps =>
                                props.user?.data?.status === 'Submitted'
                                  ? <Redirect to={`/exams/${routeProps.match.params.id}/summary`} />
                                  : <QuestionPage2 {...routeProps} />
                              } />
                              <Redirect to="/welcome" />
                            </Switch>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* <!-- Footer --> */}
                    <Footer />
                    {/* <!-- End of Footer --> */}

                </div>
                {/* <!-- End of Content Wrapper --> */}

            </div>
            {/* <!-- End of Page Wrapper --> */}

            {/* <!-- Scroll to Top Button --> */}
            <Scroll />

            {/* <!-- Logout Modal --> */}
            
        </React.Fragment>
    );
  }else {
    routes = (
      <Switch>
        <Route exact path="/" component={LoginForm} />
        {/* <Route exact path="/"> {props.isSignedIn ? <Redirect to="/welcome" /> : <LoginForm />}</Route> */}
        <Redirect to="/" />
      </Switch>
    );
  }

  return (
    <Router history={history}>
      <>
        {/* <NetworkConnectionModal isOpen={isOpen} toggle={ toggle } /> */}
        {/* <PreSubmitModal isOpen={openPresubmit} toggle={ togglePresubmit } /> */}
        <ToastContainer />
        <Switch>
          <Route exact path="/exams/:id/summary" component={Summary} />
          <Route>{routes}</Route>
        </Switch>
      </>
    </Router>
  );
}

const mapStateToProps = state => {
  return {isSignedIn: state.auth.isSignedIn, user: state.auth?.user }
}

export default  connect(mapStateToProps, {fetchUser, signout})(App);
